import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box
} from '@mui/material';

interface ConfigModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ConfigModal: React.FC<ConfigModalProps> = ({ open, onClose, children }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          background: '#fff',
          border: '1px solid #b3b3b3',
          minWidth: 600
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, pt: 2, pb: 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 400, color: '#222', fontSize: 20 }}>
          Configuración
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: '#888' }}>
          ✕
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 2, pt: 1 }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default ConfigModal; 